import { useContext } from 'react';
import { ConfigContext } from '../../contexts/configContext'

// ==============================|| CONFIG - HOOKS ||============================== //

export default function useConfig() {
	return useContext(ConfigContext);
}
